import React from 'react';
import { SubjectSiteAccount } from 'api/subjectSiteApi';
import LogoWhite from 'images/subjectSite/GetSet4Edu_Logo_White.png';
import { SIGN_OUT_LINK, SubjectSiteLink } from './subjectSiteMenu';
import SubjectSiteMenuLink from './SubjectSiteMenuLink';

type Props = {
  isOpen: boolean;
  menuLinks: SubjectSiteLink[];
  account: SubjectSiteAccount | null;
  /**
   * Loading has ended, so the school menu and Logout show even when the
   * school's details could not be loaded
   */
  bAccountLoaded: boolean;
  schoolLinks: SubjectSiteLink[];
  onLessonMenuOpen: (() => void) | null;
};

/**
 * The menu that slides in from the left on screens too narrow for the header's menus
 */
const SubjectSiteSideMenu: React.FC<Props> = ({
  isOpen,
  menuLinks,
  account,
  bAccountLoaded,
  schoolLinks,
  onLessonMenuOpen,
}) => {
  const linkTabIndex = isOpen ? undefined : -1;

  return (
    <div className={`SideMenu${isOpen ? ' Opened' : ''}`} aria-hidden={!isOpen}>
      <div className="OverflowPanel1">
        <div className="MenuMobile">
          <div className="TopBanner">
            <div className="Img">
              <img src={LogoWhite} alt="GetSet4Education" />
            </div>
          </div>

          <div className="LeftMenu Nav">
            <ul className="Level1">
              {onLessonMenuOpen && (
                <li className="Level1">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    className="Level1"
                    href="#"
                    tabIndex={linkTabIndex}
                    onClick={(event) => {
                      event.preventDefault();
                      onLessonMenuOpen();
                    }}
                  >
                    Lesson Plans
                  </a>
                </li>
              )}
              {menuLinks.map((link) => (
                <li className="Level1" key={link.name}>
                  <SubjectSiteMenuLink
                    link={link}
                    className="Level1"
                    tabIndex={linkTabIndex}
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className="RightMenu Nav">
            <ul className="Level1">
              {bAccountLoaded && (
                <li className="Level1">
                  {/* A heading for the school's links, styled as the menu's links */}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a className="Level1 SchoolName">
                    <span className="NameTxt">{account?.schoolName}</span>
                    <span className="Nav_Arrow"></span>
                  </a>
                  <ul className="Level2">
                    {schoolLinks.map((link) => (
                      <li className="Level2" key={link.name}>
                        <SubjectSiteMenuLink
                          link={link}
                          className="Level2"
                          tabIndex={linkTabIndex}
                        />
                      </li>
                    ))}
                    <li className="Level2">
                      <SubjectSiteMenuLink
                        link={SIGN_OUT_LINK}
                        className="Level2 BtnLogout"
                        tabIndex={linkTabIndex}
                      >
                        <span>Logout</span>
                      </SubjectSiteMenuLink>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectSiteSideMenu;
